import React from "react";
import BlogHero from "./components/blog/BlogHero";
import BlogPost from "./components/blog/BlogPost";

export default function BlogView() {
  return (
    <>
      <BlogHero />
      <BlogPost />
    </>
  );
}
